import { InjectionToken } from '@angular/core';

export const BASE_CONFIG = new InjectionToken<any>('BASE_APP_CONFIG');
